import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["street", "city", "state", "postalCode", "country"]

  connect() {
    this.initializeAutocomplete()
  }

  async initializeAutocomplete() {
    await google.maps.importLibrary("places");

    try {
      const autocomplete = new google.maps.places.Autocomplete(this.streetTarget, {
        types: ['address'],
        fields: ['address_components', 'formatted_address']
      })

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()
        if (!place.address_components) return

        this.fillAddressFields(place)
      })
    } catch (error) {
      console.error('Error initializing Places Autocomplete:', error)
    }
  }

  fillAddressFields(place) {
    // Clear existing values
    this.cityTarget.value = ''
    this.stateTarget.value = ''
    this.postalCodeTarget.value = ''
    this.countryTarget.value = ''

    let streetNumber = ''
    let route = ''

    // Fill in values from selected place
    for (const component of place.address_components) {
      const type = component.types[0]
      const value = component.long_name

      switch(type) {
        case 'street_number':
          streetNumber = value
          break
        case 'route':
          route = value
          break
        case 'locality':
          this.cityTarget.value = value
          break
        case 'administrative_area_level_1':
          this.stateTarget.value = value
          break
        case 'postal_code':
          this.postalCodeTarget.value = value
          break
        case 'country':
          this.countryTarget.value = value
          break
      }
    }

    // Combine street number and route for full street address
    this.streetTarget.value = `${streetNumber} ${route}`.trim()
  }
}
